import {
    useMutation,
    useQueryClient,
  } from '@tanstack/react-query';
  
  import { createLibraryV1 } from './api';
  import { libraryAuthoringQueryKeys } from '../../data/apiHooks';
  
  /**
   * Hook that provides a "mutation" that can be used to create a new content library (v1).
   */
  // eslint-disable-next-line import/prefer-default-export
  export const useCreateLibraryV1 = () => {
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: createLibraryV1,
      onSettled: () => {
        queryClient.invalidateQueries({ queryKey: libraryAuthoringQueryKeys.contentLibraryList() });
      },
    });
  };
  